import React from 'react';

type Props = {
  ariaLabel: string;
  className?: string;
  color?: string;
  size?: number;
};

export const EmoticonAngry = ({
  ariaLabel,
  className,
  color = '#505050',
  size = 21,
}: Props) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={ariaLabel}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="#FFF"
          fillOpacity="0"
          d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2zm0 14c-3.866 0-7 3.526-7 7.875 0 0 3.542 1.125 7.063 1.125C19.542 25 23 23.875 23 23.875 23 19.525 19.866 16 16 16z"
        />
        <path
          stroke={color}
          strokeWidth="2"
          d="M10.035 23.13c1.178.314 3.608.87 6.028.87 2.38 0 4.749-.551 5.903-.865-.152-1.618-.794-3.073-1.764-4.164C19.127 17.76 17.645 17 16 17s-3.127.761-4.202 1.97c-.97 1.091-1.611 2.544-1.763 4.16z"
        />
        <g stroke={color} strokeWidth="2">
          <path d="M23.741 8.5l-3.586 4h5.09M8.504 8.5l3.587 4H7" />
        </g>
      </g>
    </svg>
  );
};

export const EmoticonDissatisfied = ({
  ariaLabel,
  className,
  color = '#505050',
  size = 21,
}: Props) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={ariaLabel}
    >
      <g fill="none" fillRule="evenodd">
        <g stroke={color} strokeWidth="2">
          <path d="M20 18a6 6 0 0 0-6 6M22.618 12.25c-.329.332-.704.5-1.118.5-.414 0-.79-.168-1.06-.44l2.178-.06zm-11 0c-.329.332-.704.5-1.118.5-.414 0-.79-.168-1.06-.44l2.178-.06z" />
        </g>
      </g>
    </svg>
  );
};

export const EmoticonNeutral = ({
  ariaLabel,
  className,
  color = '#505050',
  size = 21,
}: Props) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={ariaLabel}
    >
      <g fill="none" fillRule="evenodd">
        <g stroke={color} strokeWidth="2">
          <circle cx="10" cy="12" r="1" />
          <circle cx="22" cy="12" r="1" />
          <path d="M12 20.5h8" />
        </g>
      </g>
    </svg>
  );
};

export const EmoticonSmiling = ({
  ariaLabel,
  className,
  color = '#505050',
  size = 21,
}: Props) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={ariaLabel}
    >
      <g fill="none" fillRule="evenodd">
        <g stroke={color} strokeWidth="2">
          <path d="M10 18a6 6 0 1 0 12 0M11 12a.997.997 0 0 1-1 1 .997.997 0 0 1-1-1 .997.997 0 0 1 1-1 .997.997 0 0 1 1 1zm12 0a.997.997 0 0 1-1 1 .997.997 0 0 1-1-1 .997.997 0 0 1 1-1 .997.997 0 0 1 1 1z" />
        </g>
      </g>
    </svg>
  );
};

export const EmoticonLaughing = ({
  ariaLabel,
  className,
  color = '#505050',
  size = 21,
}: Props) => {
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 32 32"
      role="img"
      aria-label={ariaLabel}
    >
      <g fill="none" fillRule="evenodd">
        <path
          fill="none"
          d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2zm.063 14C12.542 16 9 17.125 9 17.125 9 21.475 12.134 25 16 25s7-3.526 7-7.875c0 0-3.458-1.125-6.937-1.125z"
        />
        <g stroke={color} strokeWidth="2">
          <path d="M10.035 17.87c1.178-.314 3.608-.87 6.028-.87 2.38 0 4.749.551 5.903.865-.152 1.618-.794 3.073-1.764 4.164C19.127 23.24 17.645 24 16 24s-3.127-.761-4.202-1.97c-.97-1.091-1.611-2.544-1.763-4.16zM13.215 12.456a3 3 0 1 0-5.909 1.042M24.694 13.498a3 3 0 0 0-5.909-1.042" />
        </g>
      </g>
    </svg>
  );
};
